import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Logger, I18nService } from '@app/core';
var log = new Logger('App');
var AppComponent = /** @class */ (function () {
    function AppComponent(router, activatedRoute, titleService, translateService, i18nService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.translateService = translateService;
        this.i18nService = i18nService;
    }
    AppComponent.prototype.ngOnInit = function () {
        // Setup logger
        if (environment.production) {
            Logger.enableProductionMode();
        }
        log.debug('init');
        // Setup translations
        this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);
        $.fn.datepicker.defaults.format = 'dd/M/yyyy';
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js